// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form-button button.with-icon {
  padding: 14px 40px 14px 24px;
}
form-button button:disabled {
  cursor: not-allowed;
}
form-button .icon-ctr {
  position: relative;
  display: inline-block;
  width: 28px;
  height: 10px;
}
form-button .icon-ctr ex-icon {
  position: absolute;
  font-size: 1.6em;
  color: #666;
  top: -8px;
  left: 0;
}
form-button.red {
  margin-left: 10px;
}
form-button.red button:hover {
  background-color: rgb(255, 110, 110);
  color: #fff;
}
form-button.red button:hover ex-icon {
  color: #fff;
}
form-button.small {
  font-size: 0.85em;
}
form-button.small button {
  padding: 14px 25px;
  border-radius: 6px;
}
form-button.small button.with-icon {
  padding: 14px 20px 14px 5px;
}
form-button.small ex-icon {
  top: -4px;
  left: 7px;
}`, "",{"version":3,"sources":["webpack://./src/resources/elements/form-button/form-button.scss"],"names":[],"mappings":"AAEI;EACE,4BAAA;AADN;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAJJ;AAMI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;AAJN;AAQE;EACE,iBAAA;AANJ;AASM;EACE,oCAAA;EACA,WAAA;AAPR;AASQ;EACE,WAAA;AAPV;AAaE;EACE,iBAAA;AAXJ;AAaI;EACE,kBAAA;EACA,kBAAA;AAXN;AAaM;EACE,2BAAA;AAXR;AAeI;EACE,SAAA;EACA,SAAA;AAbN","sourcesContent":["form-button {\n  button {\n    &.with-icon {\n      padding: 14px 40px 14px 24px;\n    }\n  }\n\n  button:disabled{\n    cursor: not-allowed;\n  }\n\n  .icon-ctr {\n    position: relative;\n    display: inline-block;\n    width: 28px;\n    height:10px;\n\n    ex-icon {\n      position: absolute;\n      font-size: 1.6em;\n      color: #666;\n      top:-8px;\n      left:0;\n    }\n  }\n\n  &.red {\n    margin-left: 10px;\n\n    button {\n      &:hover {\n        background-color: rgb(255, 110, 110);\n        color: #fff;\n\n        ex-icon {\n          color: #fff;\n        }\n      }\n    }\n  }\n\n  &.small {\n    font-size: 0.85em;\n\n    button {\n      padding: 14px 25px;\n      border-radius: 6px;\n\n      &.with-icon {\n        padding: 14px 20px 14px 5px;\n      }\n    }\n\n    ex-icon {\n      top:-4px;\n      left:7px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
